import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import ExperienceMember from './ExperienceMember';
import FavoriteItem from './FavoriteItem';


export default function ManufacturerPartnerMember(props) {

    const {t, i18n} = useTranslation();


    const [isUser, setIsUser] = React.useState(false);

    const toggleMessageModal = () => {
        const partnerId = props.hit.objectID.slice(2);
        openMessageModal(partnerId, 'partner');
    };

    useEffect(() => {
        if (typeof window.is_user !== 'undefined') {
            if (window.is_user === 'True') {
                setIsUser(true)
            }
        }
    }, []);

    const profileImage = () => {
        if (props.hit.is_preferred) {
            return props.hit.directory_image;
        }
        //return '/static/images/NonPreferredPartnerIcon.png';
        return '/static/images/svg/NonPreferredPartnerIcon.svg';
    }

    const profileLink = () => {
        if (window.win_language_code !== 'en') {
            return '/' + window.win_language_code + props.hit.directory_link
        }
        return props.hit.directory_link
    }

    return (
        <React.Fragment>
            <div className="individuals__item">
                <div className="individual">
                    <div className="individual__inner">
                        <figure>
                            <img src={props.hit.directory_image} alt=""/>
                        </figure>

                        <div className="individual__content">
                            <div className="individual__head">
                                <h4>{props.hit.name}</h4>
                            </div>

                            <div className="individual__title">
                                <p>
                                    {props.hit.directory_job}<br/>
                                    <span>WoodWorks Partner</span>
                                </p>
                            </div>
                        </div>
                    </div>

                    <aside className="individual__aside">

                        <ExperienceMember hit={props.hit}/>
                        {props.hit.is_preferred &&
                        <div className="individual__actions">
                            <a href={profileLink()} className="btn btn--outline">
                                {t('Directory.ViewPro')}
                            </a>
                            <FavoriteItem item={props.hit}/>

                        </div>
                        }
                        {!props.hit.is_preferred &&
                        <div className="individual__actions">
                            <a href="#" className="btn btn--outline black-outline" onClick={toggleMessageModal}>
                                Contact
                            </a>
                        </div>
                        }
                    </aside>
                </div>
            </div>
        </React.Fragment>
    );
}
